import { useQuery } from '../../../hooks';
import { FivetranConnectionCacheKeys } from '../consts';

import * as connectionsService from '../service';

export const useFivetranConnectionTypes = () => {
  const getFivetranConnectionTypes = useQuery({
    queryFn: connectionsService.getFivetranConnectionTypes,
    queryKey: [FivetranConnectionCacheKeys.GetConnectionTypes],
  });

  return {
    getFivetranConnectionTypes,
  };
};
